export default function BlogContent() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="prose prose-lg max-w-none">
          <div className="text-gray-700 leading-relaxed space-y-6">
            <p className="text-xl text-gray-600 font-medium">
              In the world of concrete construction, the gap between a "good" project and a "profitable" one is often measured in inches. For project managers in Vancouver and the Lower Mainland, having clear, technical drawings is the only way to bridge that gap.
            </p>

            <p>
              At <strong>Dinari Designs</strong>, we rely on the industry's most trusted tools—<strong>AutoCAD</strong> and <strong>Bluebeam Revu</strong>—to deliver layout designs that are as accurate on the job site as they are on the screen. Here's why this technical focus matters for your project:
            </p>

            <div className="bg-slate-50 border-l-4 border-teal-500 p-6 my-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center">
                <span className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-pencil-ruler-2-line text-white text-xl"></i>
                </span>
                1. Precision Drafting with AutoCAD
              </h2>
              <p className="text-gray-700 mb-0">
                Every line matters. By utilizing <strong>AutoCAD</strong>, we provide high-fidelity formwork drawings that integrate seamlessly with your existing architectural and structural plans. This ensures that every bulkhead, slab edge, and column location is accounted for before the first nail is driven.
              </p>
            </div>

            <div className="bg-slate-50 border-l-4 border-teal-500 p-6 my-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center">
                <span className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-file-list-3-line text-white text-xl"></i>
                </span>
                2. Detailed Material Takeoffs with Bluebeam Revu
              </h2>
              <p className="text-gray-700 mb-0">
                Managing costs requires knowing exactly what you need. Using <strong>Bluebeam Revu</strong>, we provide hyper-accurate material takeoffs (BOQs). Whether it's plywood, lumber, or specialized hardware, our digital measurements reduce over-ordering and keep your overhead lean.
              </p>
            </div>

            <div className="bg-slate-50 border-l-4 border-teal-500 p-6 my-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center">
                <span className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-team-line text-white text-xl"></i>
                </span>
                3. Seamless Coordination
              </h2>
              <p className="text-gray-700 mb-0">
                Because we use industry-standard software, sharing files with engineers, architects, and sub-contractors is effortless. No compatibility issues—just clean, professional PDFs and DWG files that keep the whole team on the same page.
              </p>
            </div>

            <div className="bg-slate-50 border-l-4 border-teal-500 p-6 my-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center">
                <span className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-timer-flash-line text-white text-xl"></i>
                </span>
                4. Fast Turnarounds for Busy Sites
              </h2>
              <p className="text-gray-700 mb-0">
                Construction moves fast. Our expertise in <strong>Bluebeam</strong> allows us to mark up revisions and process layout changes rapidly. We understand the "boots on the ground" reality, which is why we commit to a <strong>24-48 hour response time</strong> for quotes and consultations.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 my-12 text-white">
              <h2 className="text-3xl font-bold mb-4">
                Ready to lean out your overhead?
              </h2>
              <p className="text-lg mb-6 text-teal-50">
                Don't leave your site layout to chance. From Fraser Commons to your next custom residential build, trust the precision of <strong>AutoCAD</strong> and the accuracy of <strong>Bluebeam</strong>.
              </p>
              <a 
                href="/home#contact" 
                className="inline-flex items-center px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Get a Quote
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>

            <div className="border-t border-gray-200 pt-8 mt-12">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center space-x-4">
                  <span className="text-sm font-medium text-gray-500">Share this article:</span>
                  <div className="flex space-x-3">
                    <a href="#" className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center hover:bg-teal-500 hover:text-white transition-colors cursor-pointer">
                      <i className="ri-linkedin-fill"></i>
                    </a>
                    <a href="#" className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center hover:bg-teal-500 hover:text-white transition-colors cursor-pointer">
                      <i className="ri-twitter-x-fill"></i>
                    </a>
                    <a href="#" className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center hover:bg-teal-500 hover:text-white transition-colors cursor-pointer">
                      <i className="ri-facebook-fill"></i>
                    </a>
                  </div>
                </div>
                <a 
                  href="/knowledge-hub" 
                  className="text-teal-600 hover:text-teal-700 font-medium flex items-center cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line mr-2"></i>
                  Back to Knowledge Hub
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
